  import { Component } from '@angular/core';
  import { environment } from 'src/environments/environment';
  import { AmdocsEventBusService } from 'amdocs-core-package';
  import { CONSTANTS } from 'src/app/constants';
  import { UserService } from 'src/app/service/user.service';
  @Component({
    selector: 'app-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.scss']
  })
  export class FooterComponent {
    public currentYear:number = new Date().getFullYear();
    public copyRightsUrl=environment.footerConfig.copyrights;
    public amdocsUrl=environment.footerConfig.wwwAmdocs;
    constructor(private amdocsEventService:AmdocsEventBusService,private userService:UserService) {
    }

    showTerms(){
      this.saveUserActivity('TermsPopUp');
      this.amdocsEventService.emit(CONSTANTS.EVENTS.SHOW_TERMS,true);
    }

    saveUserActivity(urlType?:string):void{
       const activityPayload={
        actionType: CONSTANTS.STATISTICS.FooterClick,
        eventType:CONSTANTS.STATISTICS.Activity,
        created: new Date().toISOString(),
        landingPage:CONSTANTS.STATISTICS.Home,
      
      }
      this.userService.saveUserActivity(activityPayload);
    }
    
  }
